import { render, staticRenderFns } from "./DriversLicenseCapture.vue?vue&type=template&id=7156bfba&scoped=true"
import script from "./DriversLicenseCapture.vue?vue&type=script&lang=js"
export * from "./DriversLicenseCapture.vue?vue&type=script&lang=js"
import style0 from "./DriversLicenseCapture.vue?vue&type=style&index=0&id=7156bfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156bfba",
  null
  
)

export default component.exports